








































































import Quadrant from '@/domain/matrix-config/entity/quadrant.entity';
import { Vue, Component, Prop } from 'vue-property-decorator';
import Rules from '@/shared/rules/rules';
import HexColorPicker from '@/shared/hex-color-picker/hex-color-picker.component.vue';
import LabelSlot from '@/shared/slots/label-slot.component.vue';

const POTENTIALS = {
  1: 'Baixo',
  2: 'Médio',
  3: 'Alto',
};

const PERFORMANCES = {
  3: 'Baixa',
  2: 'Média',
  1: 'Alta',
}

@Component({
  components: {
    HexColorPicker,
    LabelSlot,
  },
})
export default class QuadrantEdit extends Vue {
  @Prop({ type: Quadrant, required: true })
  quadrant!: Quadrant

  @Prop({ type: Boolean, default: false })
  readonly!: boolean;

  rules: Rules = new Rules();

  get subtitle(): string {
    const quadrantPotential = POTENTIALS[this.quadrant.xAxisLevel.position];
    const quadrantPerformance = PERFORMANCES[this.quadrant.yAxisLevel.position];
    if (!quadrantPerformance) {
      return `${quadrantPotential} Potencial`
    }
    if (!quadrantPotential) {
      return `${quadrantPerformance} Performance`;
    }
    if (quadrantPotential && quadrantPerformance) {
      return `${quadrantPotential} Potencial / ${quadrantPerformance} Performance`;
    }
    return '';
  }

  inputQuadrantLabel(value: string) {
    this.$emit('inputQuadrantLabel', value);
  }

  inputQuadrantDescription(value: string) {
    this.$emit('inputQuadrantDescription', value);
  }

  inputQuadrantColor(value: string) {
    this.$emit('inputQuadrantColor', value);
  }

  inputQuadrantTextColor(value: string) {
    this.$emit('inputQuadrantTextColor', value);
  }

  close() {
    this.$emit('close');
  }

  reload() {
    this.$emit('reload');
  }
}
